import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { RumiService } from 'src/app/services/rumi.service';

@Component({
  selector: 'app-resultat-risc',
  templateUrl: './resultat-risc.component.html'
})
export class ResultatRiscComponent implements OnInit {

  public get resultat() {
    return this.rumiService.simulacio.resultat;
  }

  constructor(
    public translate: TranslateService,
    private router: Router,
    private rumiService: RumiService
  ) { }

  ngOnInit() {    
    this.rumiService.pestanyaActiva = this.router.url;
  }

  goToNextStep() {
    this.router.navigate(['simulacio','accions']);
  }

  goToPrevStep() {
    this.router.navigate(['simulacio','altres-observacions']);
  }

	navigate(url: String){
	  this.router.navigate([url]);
	}

}
